import { defaultTo, difference, isEmpty, isNil, omit, propOr } from '../../utils/fp';
import highlightParser from './highlightParser';
import C from './constants';

const markTag = /<(\/)?mark>/g;

const parseHighlights = highlightsObj =>
  Object.entries(highlightsObj).reduce((memo, [field, highlight]) => {
    const items = highlight.map(highlightParser).filter(item => !isNil(item));
    if (items.every(isEmpty)) return memo;
    return [...memo, [field === C.DATASOURCE_ID ? 'Id' : field, items]];
  }, []);

const enhanceDimensions = (dimensions = [], highlights) => {
  const stripped = highlights.map(highlight => highlight.replace(markTag, ''));
  return [...highlights, ...difference(dimensions, stripped)];
};

const getHightlightedField = key => highlights => propOr([], key, highlights)[0];
const getHightlight = ({ field, fieldKey, highlights = {} }) => {
  if (isNil(fieldKey)) return field;

  // if <mark> is used in field, false positive
  // if field is in html, highlighted field may break original html
  const hightlightedField = getHightlightedField(fieldKey)(highlights);

  if (isNil(hightlightedField)) return field;

  const stripped = hightlightedField.replace(markTag, '');
  return field.replace(stripped, hightlightedField);
};

export default options => data => {
  const { id, name, description, dimensions, ...dataflow } = data;
  const highlights = propOr({}, id, options.highlighting);

  const highlightedName = defaultTo(
    defaultTo(id, name),
    getHightlight({ field: name, fieldKey: 'name', highlights }),
  );

  return {
    ...dataflow,
    id,
    name: highlightedName,
    description: getHightlight({
      field: description,
      fieldKey: 'description',
      highlights,
    }),
    dimensions: enhanceDimensions(dimensions, propOr([], 'dimensions', highlights)),
    highlights: parseHighlights(omit(['name', 'description', 'dimensions'], highlights)),
  };
};
